<template>
  <form
    class="ecommerce-form action-buttons-fixed"
    @submit.prevent="submitForm"
    novalidate
  >
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-slider"></i>
                <h2 class="card-big-info-title">Detalji</h2>
              </div>

              <div class="col-lg-3-5 col-xl-4-5">
                <div
                  class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.title.$invalid && $v.$dirty }"
                >
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Naziv</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      placeholder="Naziv"
                      v-model="title"
                    />

                    <form-error
                      :model="$v.title"
                      :dirty="$v.$dirty"
                      label="Naziv"
                    />
                  </div>
                </div>

                <div
                  class="form-group row align-items-center mb-3"
                  :class="{
                    'has-danger': $v.description.$invalid && $v.$dirty,
                  }"
                >
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Opis</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="description"
                    ></textarea>

                    <form-error
                      :model="$v.description"
                      :dirty="$v.$dirty"
                      label="Opis"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Nadredjena kategorija</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <treeselect
                      v-model="parentCategoryId"
                      :multiple="false"
                      :options="categories"
                      :show-count="true"
                      placeholder="Izaberite kategoriju"
                      v-if="categories"
                    />
                  </div>
                </div>

                <div
                  class="form-group row align-items-center mb-3"
                  :class="{ 'has-danger': $v.order.$invalid && $v.$dirty }"
                >
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Prioritet</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="number"
                      class="form-control form-control-modern"
                      placeholder="Prioritet"
                      v-model="order"
                      min="0"
                    />
                    <form-error
                      :model="$v.order"
                      :dirty="$v.$dirty"
                      label="Prioritet"
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center mb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Slika kategorije</label
                  >
                  <div class="col-lg-7 col-xl-6">
                    <input
                      type="file"
                      class="form-control form-control-modern"
                      ref="photo"
                      accept="image/*"
                    />
                    <span class="form-text">
                      Učitajte sliku rezolucije 400px x 320px
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-tag"></i>
                  <h2 class="card-big-info-title">{{ translations.metaSeoDetails }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.metaSeo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naslov</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="metaSeo.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Opis"
                        v-model="metaSeo.description"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Keyword</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Keyword"
                        v-model="metaSeo.keyword"
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
      </div>
    </div>
    <div class="row action-buttons">
      <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
        <router-link
          exact
          :to="{ name: 'Categories' }"
          class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
        >
          {{ translations.cancel }}
        </router-link>
        <button
          type="submit"
          class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
        >
          <i class="bx bx-save text-4 me-2"></i>{{ translations.save }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import api from '@/services/api';
import validations from './validation-schema/add';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  components: { FormError, Treeselect },
  name: 'AddCategory',
  mixins: [translations],
  validations,
  computed: {
    categories() {
      return this.$store.getters.getCategoriesTree;
    },
  },
  data() {
    return {
      title: '',
      description: '',
      parentCategoryId: null,
      order: null,
      metaSeo: {
        title: null,
        description: null,
        keyword: null,
      }
    };
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      const { title, description, parentCategoryId, order } = this;

      const formData = new FormData();

      formData.append('title', title);
      formData.append('description', description);
      formData.append('order', order);

      if (this.$refs.photo.files[0]) {
        formData.append('Image', this.$refs.photo.files[0]);
      }

      if (parentCategoryId) {
        formData.append('parentCategoryId', parentCategoryId);
      }

      if (this.metaSeo.title) {
        formData.append('metaSeo.title', this.metaSeo.title);
      }

      if (this.metaSeo.description) {
        formData.append('metaSeo.description', this.metaSeo.description);
      }

      if (this.metaSeo.keyword) {
        formData.append('metaSeo.keyword', this.metaSeo.keyword);
      }

      if (!this.$v.$invalid) {
        api
          .addCategory(formData)
          .then((response) => {
            this.$toast.info(response.data.info);
            this.$router.push({ name: 'Categories' });
          })
          .catch((err) => {
            this.$toast.error(err.response.data.info);
          });
      } else {
        this.$toast.error(this.translations.forms.notValid);
      }
    },
  },
  mounted() {
    this.$store.dispatch('getSimplifiedCategories', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
  },
};
</script>
